"use client";

import { c as _c } from "react/compiler-runtime";
import type { NFT } from "@/entities/INFT";
import type { NextGenCollection } from "@/entities/INextgen";
import type { Transaction } from "@/entities/ITransaction";
import useIsMobileScreen from "@/hooks/isMobileScreen";
import { useActivityData } from "@/hooks/useActivityData";
import { useActivityFilters } from "@/hooks/useActivityFilters";
import { useNFTCollections } from "@/hooks/useNFTCollections";
import { useEffect, useState } from "react";
import { Container, Row } from "react-bootstrap";
import Pagination from "../pagination/Pagination";
import ActivityFilters from "./ActivityFilters";
import ActivityHeader from "./ActivityHeader";
import ActivityTable from "./ActivityTable";
interface Props {
  page: number;
  pageSize: number;
  showMore?: boolean | undefined;
  // Optional props for SSR
  initialActivity?: Transaction[] | undefined;
  initialTotalResults?: number | undefined;
  initialNfts?: NFT[] | undefined;
  initialNextgenCollections?: NextGenCollection[] | undefined;
}
export default function LatestActivity(props) {
  const $ = _c(40);
  const isMobile = useIsMobileScreen();
  const {
    typeFilter,
    selectedContract,
    setTypeFilter,
    setSelectedContract
  } = useActivityFilters();
  let t0;
  if ($[0] !== props.initialActivity || $[1] !== props.initialTotalResults) {
    t0 = props.initialActivity && props.initialTotalResults !== undefined ? {
      activity: props.initialActivity,
      totalResults: props.initialTotalResults
    } : undefined;
    $[0] = props.initialActivity;
    $[1] = props.initialTotalResults;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const {
    activity,
    totalResults,
    fetching,
    page,
    setPage
  } = useActivityData(props.page, props.pageSize, typeFilter, selectedContract, t0);
  let t1;
  if ($[3] !== props.initialNextgenCollections || $[4] !== props.initialNfts) {
    t1 = props.initialNfts && props.initialNextgenCollections ? {
      nfts: props.initialNfts,
      nextgenCollections: props.initialNextgenCollections
    } : undefined;
    $[3] = props.initialNextgenCollections;
    $[4] = props.initialNfts;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const {
    nfts,
    nextgenCollections
  } = useNFTCollections(t1);
  const [showViewAll, setShowViewAll] = useState(false);
  let t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setShowViewAll(!window.location.pathname.includes("nft-activity"));
    };
    t3 = [];
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  if ($[8] !== fetching || $[9] !== showViewAll) {
    t4 = <ActivityHeader showViewAll={showViewAll} fetching={fetching} />;
    $[8] = fetching;
    $[9] = showViewAll;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== setPage || $[12] !== setTypeFilter) {
    t5 = filter => setTypeFilter(filter, () => setPage(1));
    $[11] = setPage;
    $[12] = setTypeFilter;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== setPage || $[15] !== setSelectedContract) {
    t6 = contract => setSelectedContract(contract, () => setPage(1));
    $[14] = setPage;
    $[15] = setSelectedContract;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== isMobile || $[18] !== selectedContract || $[19] !== t5 || $[20] !== t6 || $[21] !== typeFilter) {
    t7 = <ActivityFilters typeFilter={typeFilter} selectedContract={selectedContract} onTypeFilterChange={t5} onContractFilterChange={t6} isMobile={isMobile} />;
    $[17] = isMobile;
    $[18] = selectedContract;
    $[19] = t5;
    $[20] = t6;
    $[21] = typeFilter;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== t4 || $[24] !== t7) {
    t8 = <Row className="d-flex align-items-center">{t4}{t7}</Row>;
    $[23] = t4;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== activity || $[27] !== nextgenCollections || $[28] !== nfts) {
    t9 = <ActivityTable activity={activity} nfts={nfts} nextgenCollections={nextgenCollections} />;
    $[26] = activity;
    $[27] = nextgenCollections;
    $[28] = nfts;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== page || $[31] !== props.pageSize || $[32] !== props.showMore || $[33] !== setPage || $[34] !== totalResults) {
    t10 = props.showMore && totalResults > 0 && <Row className="text-center pt-2 pb-3"><Pagination page={page} pageSize={props.pageSize} totalResults={totalResults} setPage={function (newPage) {
        setPage(newPage);
        window.scrollTo(0, 0);
      }} /></Row>;
    $[30] = page;
    $[31] = props.pageSize;
    $[32] = props.showMore;
    $[33] = setPage;
    $[34] = totalResults;
    $[35] = t10;
  } else {
    t10 = $[35];
  }
  let t11;
  if ($[36] !== t10 || $[37] !== t8 || $[38] !== t9) {
    t11 = <Container className="no-padding pt-4">{t8}{t9}{t10}</Container>;
    $[36] = t10;
    $[37] = t8;
    $[38] = t9;
    $[39] = t11;
  } else {
    t11 = $[39];
  }
  return t11;
}